import { useToggleFavorite } from "@/api/resourceTags";
import type { ObjectActionHandlers } from "@/object-actions/types";
import { useOpenConnection } from "@/panes/connection/useOpenConnection";
import {
  RESOURCE_TAG_FAVORITE,
  type IntegrationConnection,
} from "@cohesive/api-client";
import { useMemo } from "react";

/** Registry handlers for a Connectors-rail integration connection row. */
export function useConnectorObjectActionHandlers(
  connection: IntegrationConnection,
): ObjectActionHandlers {
  const toggleFavorite = useToggleFavorite();
  const openConnection = useOpenConnection();
  const isFavorite = !!connection.tags?.includes(RESOURCE_TAG_FAVORITE);

  return useMemo((): ObjectActionHandlers => {
    const toggle = () =>
      toggleFavorite.mutate({
        resourceType: "integration-connection",
        resourceId: connection.id,
        isFavorite,
      });
    return {
      star: () => window.setTimeout(toggle, 0),
      unstar: () => window.setTimeout(toggle, 0),
      manage: () =>
        window.setTimeout(() => openConnection(connection.integration_id), 0),
    };
  }, [connection, isFavorite, openConnection, toggleFavorite]);
}
